import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TodoFilterContextType {
  currentListId: number | string | null;
  setCurrentListId: (listId: number | string | null) => void;
}

const TodoFilterContext = createContext<TodoFilterContextType | undefined>(undefined);

interface TodoFilterProviderProps {
  children: ReactNode;
}

export const TodoFilterProvider: React.FC<TodoFilterProviderProps> = ({ children }) => {
  const [currentListId, setCurrentListId] = useState<number | string | null>(null);

  return (
    <TodoFilterContext.Provider value={{ currentListId, setCurrentListId }}>
      {children}
    </TodoFilterContext.Provider>
  );
};

export const useTodoFilter = (): TodoFilterContextType => {
  const context = useContext(TodoFilterContext);
  if (context === undefined) {
    // Return a default implementation when not within provider
    return {
      currentListId: null,
      setCurrentListId: () => {},
    };
  }
  return context;
};
